"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Switch = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _pittaModules = require("@thingsw/pitta-modules");
var _Switch = _interopRequireDefault(require("@material-ui/core/Switch"));
var _clsx3 = _interopRequireDefault(require("clsx"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyle = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: 40,
      height: 22,
      padding: 0,
      '&>.Mui-disabled': {
        color: _pittaModules.LightColors.primary['0'],
        '& + $track': {
          backgroundColor: _pittaModules.LightColors.primary['4'],
          opacity: 1
        }
      }
    },
    darkModeRoot: {
      width: 40,
      height: 22,
      padding: 0,
      '&>.Mui-disabled': {
        color: _pittaModules.LightColors.primary['0'],
        '& + $darkModeTrack': {
          backgroundColor: _pittaModules.DarkColors.primary['4'],
          opacity: 1
        }
      }
    },
    disabled: {
      opacity: 0.35
    },
    switchBase: {
      width: 18,
      height: 18,
      padding: 0,
      margin: 2,
      color: "".concat(_pittaModules.LightColors.primary['0'], "!important"),
      '&$checked': {
        margin: '2px 2px 2px 0px',
        color: _pittaModules.LightColors.primary['0'],
        '& + $track': {
          backgroundColor: _pittaModules.BlackvueLightColors.primary['7'],
          opacity: 1
        },
        '& + $darkModeTrack': {
          backgroundColor: _pittaModules.BlackvueDarkColors.primary['7'],
          opacity: 1
        }
      }
    },
    thumb: {
      width: 18,
      height: 18,
      boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.14), \n                 0px 1px 1px rgba(0, 0, 0, 0.12), \n                 0px 0px 3px rgba(0, 0, 0, 0.2)"
    },
    track: {
      borderRadius: 11,
      backgroundColor: _pittaModules.LightColors.primary['4'],
      opacity: 1,
      position: 'relative',
      '&::before': _defineProperty({
        content: '"OFF"',
        position: 'absolute',
        right: 4,
        top: '50%',
        transform: 'translateY(-50%)',
        fontSize: '0.375rem',
        fontWeight: 'bold',
        color: _pittaModules.DarkColors.primary['1']
      }, theme.breakpoints.up(_pittaModules.Webviewer.mobile), {
        fontSize: '0.5rem'
      })
    },
    darkModeTrack: {
      borderRadius: 11,
      backgroundColor: _pittaModules.DarkColors.primary['4'],
      opacity: 1,
      position: 'relative',
      '&::before': _defineProperty({
        content: '"OFF"',
        position: 'absolute',
        right: 4,
        top: '50%',
        transform: 'translateY(-50%)',
        fontSize: '0.375rem',
        fontWeight: 'bold',
        color: _pittaModules.DarkColors.primary['1']
      }, theme.breakpoints.up(_pittaModules.Webviewer.mobile), {
        fontSize: '0.5rem'
      })
    },
    checked: {
      '& + $track::before': {
        left: 6,
        content: '"ON"',
        color: _pittaModules.LightColors.primary['0']
      },
      '& + $darkModeTrack::before': {
        left: 6,
        content: '"ON"',
        color: _pittaModules.LightColors.primary['0']
      }
    }
  };
});
var Switch = function Switch(props) {
  var _clsx, _clsx2;
  var checked = props.checked,
    disabled = props.disabled,
    onChange = props.onChange,
    darkMode = props.darkMode;
  var classes = useStyle(props);
  return /*#__PURE__*/_react.default.createElement(_Switch.default, {
    disableRipple: true,
    classes: {
      root: (0, _clsx3.default)((_clsx = {}, _defineProperty(_clsx, classes.root, !darkMode), _defineProperty(_clsx, classes.darkModeRoot, darkMode), _defineProperty(_clsx, classes.disabled, disabled), _clsx)),
      switchBase: classes.switchBase,
      thumb: classes.thumb,
      track: (0, _clsx3.default)((_clsx2 = {}, _defineProperty(_clsx2, classes.track, !darkMode), _defineProperty(_clsx2, classes.darkModeTrack, darkMode), _clsx2)),
      checked: classes.checked
    },
    checked: checked,
    disabled: disabled,
    inputProps: {
      role: 'switch'
    },
    onChange: onChange
  });
};
exports.Switch = Switch;